module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tm-item-card-properties"
  }, [_c('ul', {
    staticClass: "uk-list"
  }, _vm._l((_vm.properties), function(propertyValue) {
    return _c('product-property-row', {
      key: propertyValue.ShopProperty.id,
      attrs: {
        "property": propertyValue.ShopProperty,
        "value": propertyValue.ShopPropertyValue
      }
    })
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f42cad7","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shop/Product/ProductProperties.vue
// module id = 49
// module chunks = 0